<div id="comment-no-result" class="comment-no-result pl-2 mt-2" translate>
  COMMENT_LBL_NO_COMMENT
</div>
